<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            :groupByColumn="groupByColumn"
            :groupPanelOptions="groupPanelOptions"
            :summaryOptions="summaryOptions"
            ref="grid"
            name="classSummary"
        ></dx-grid>
    </div>
</template>

<script>
export default {
    data: () => ({
        title: "Class Summary",
        url: "",
        regID: "",
        branch: "",
        groupByColumn: "",
        summaryOptions: {
            enabled: true,
            grouping: true,
            groupingSumColumns: ["count"],
            columns: [],
            alignGroupSummaryByColumn: false,
            groupingDisplayFormat: "Count: {0}",
        },
        groupPanelOptions: {
            visible: true,
            allowColumnDragging: false,
        },
        actions: [],
        columns: [
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Count",
                field: "count",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Room",
                field: "room",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher H",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher H2",
                field: "teacherH2",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Name",
                field: "teacherName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Name 2",
                field: "teacherName2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Reg ID",
                field: "regID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();
            this.branch = this.getSelectedBranch();

            const terms = await this.getTerms();
            this.actions = [
                {
                    text: "Group By",
                    type: "select",
                    values: this.getGroupByOptions(),
                    value: this.groupByColumn,
                    clearable: false,
                    align: "left",
                    onSelected: this.onGroupBySelected,
                },
                {
                    text: "Select Term",
                    type: "select",
                    values: terms,
                    value: this.regID,
                    onSelected: this.onTermSelected,
                },
            ];

            this.url = this.buildGridUrl();
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        buildGridUrl() {
            return (
                "classInfo?regID=" +
                encodeURIComponent(this.regID || "") +
                "&branch=" +
                encodeURIComponent(this.branch || "")
            );
        },
        getSelectedBranch() {
            const authState =
                this.$store && this.$store.state
                    ? this.$store.state.authentication
                    : null;
            const branch = authState ? authState.branch : "";

            if (!branch) return "";

            const normalized = String(branch).trim();
            if (
                !normalized ||
                normalized == "null" ||
                normalized.includes("null")
            ) {
                return "";
            }

            return normalized;
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = this.buildGridUrl();
            this.$refs.grid.reloadDataSource(this.url);
        },
        getGroupByOptions() {
            const options = [
                {
                    text: "No Grouping",
                    value: "",
                },
            ];

            this.columns
                .filter((column) => column.visible)
                .forEach((column) => {
                    options.push({
                        text: column.label,
                        value: column.field,
                    });
                });

            return options;
        },
        onGroupBySelected(value) {
            this.groupByColumn = value || "";
        },
    },
};
</script>
